export default {
  Title: 'Lập chứng từ hạch toán',
  Organization: 'Nhà cung cấp',
  MethodPayment: 'Hình thức thanh toán',
  Cancel: 'Hủy bỏ',
  CreateAccountingVoucher: 'Sinh CT hạch toán',
  CreateDVCFile: 'Lập hồ sơ KBNN',
  SumGroupDescription: 'Cộng gộp nội dung diễn giải',
};
